import React, { useEffect } from "react";
import { initialiseGuestView } from "slices/efficeTreeSlice";
import { resetAllState } from "slices/generalSlice";
import MainContent from "../MainContent/MainContent";
import Space from "../Space/Space";
import VideoBarContainer from "../VideoBarContainer/VideoBarContainer";

const GuestView = () => {
  useEffect(() => {
    initialiseGuestView();
    return resetAllState;
  }, []);

  useEffect(() => {
    document.getElementById("space").style.visibility = "visible";
    document.getElementById("videobar").style.visibility = "visible";
    document.getElementById("space-and-video").classList.add("guest-view");
    return () =>
      document.getElementById("space-and-video").classList.remove("guest-view");
  }, []);

  return (
    <div
      className={`home-main guest-view`}
      style={
        process.env.NODE_ENV !== "production" && false
          ? { backgroundColor: "#664412" }
          : null
      } // help me remember when im developing locally
    >
      <div className="right-section">
        <MainContent />
        <Space />
        <VideoBarContainer />
      </div>
    </div>
  );
};

export default GuestView;
